import { useState } from "react";
import { Link } from "react-router-dom";
import { postSubscriber, formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { ArrowRight, Facebook, Instagram, Youtube } from "lucide-react";
import { ACTIVE_SOCIAL_LINKS } from "@/config/socialLinks";

const COLS = [
  { title: "Alışveriş", links: [
    { to: "/kategori/tumu", label: "Tüm Ürünler" },
    { to: "/#kombin", label: "Kampanyalar" },
    { to: "/hediye", label: "Hediye" },
    { to: "/shule-club", label: "Shule Club" },
  ]},
  { title: "Kurumsal", links: [
    { to: "/hakkimizda", label: "Hakkımızda" },
    { to: "/magazalar", label: "Mağazalar" },
    { to: "/kiosklar", label: "Kiosklar" },
    { to: "/bayilik", label: "Bayilik & Franchise" },
    { to: "/iletisim", label: "İletişim" },
  ]},
  { title: "Yardım", links: [
    { to: "/hesap", label: "Sipariş Takibi" },
    { to: "/iletisim#sss", label: "İade & Değişim" },
    { to: "/iletisim#sss", label: "Sık Sorulan Sorular" },
    { to: "/iletisim", label: "Gizlilik Politikası" },
  ]},
];

const SOCIAL_ICONS = { instagram: Instagram, facebook: Facebook, youtube: Youtube };

export function Footer() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const r = await postSubscriber({ email, source: "newsletter" });
      toast.success(r.message);
      setEmail("");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <footer data-testid="site-footer" className="bg-shule-cream border-t border-shule-line mt-8 pb-24 lg:pb-0">
      <div className="container-shule py-14 lg:py-20">
        <div className="text-center">
          <Link to="/" aria-label="Shule ana sayfa" data-testid="footer-logo" className="inline-flex">
            <img src="/assets/img/logo.png" alt="Shule — Her Anında Sen" className="h-16 w-auto mx-auto" />
          </Link>
          <div className="mt-5 flex items-center justify-center gap-2">
            {ACTIVE_SOCIAL_LINKS.filter((s) => SOCIAL_ICONS[s.id]).map((s) => {
              const Icon = SOCIAL_ICONS[s.id];
              return (
                <a key={s.label} data-testid={`social-${s.label.toLowerCase()}`} href={s.href} target="_blank" rel="noopener noreferrer"
                  aria-label={s.label}
                  className="w-11 h-11 rounded-full border border-shule-lineaccent flex items-center justify-center text-shule-mocha hover:border-shule-gold hover:text-shule-goldhover transition-colors">
                  <Icon className="w-4 h-4" />
                </a>
              );
            })}
          </div>
        </div>

        <div className="mt-12 grid grid-cols-2 lg:grid-cols-4 gap-10 max-w-4xl mx-auto">
          {COLS.map((col) => (
            <div key={col.title}>
              <p className="eyebrow mb-4">{col.title}</p>
              <ul className="space-y-1">
                {col.links.map((l) => (
                  <li key={l.label}>
                    <Link data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`} to={l.to}
                      className="text-sm text-shule-mocha hover:text-shule-goldhover transition-colors inline-flex items-center min-h-[36px]">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
          <div>
            <p className="eyebrow mb-4">Shule Dünyasına Katıl</p>
            <form data-testid="newsletter-form" onSubmit={submit}>
              <div className="flex rounded-full border border-shule-lineaccent bg-shule-paper overflow-hidden focus-within:border-shule-gold transition-colors">
                <input data-testid="newsletter-email-input" type="email" required value={email}
                  onChange={(e) => setEmail(e.target.value)} placeholder="E-posta adresinizi yazın"
                  aria-label="E-posta adresi" className="flex-1 min-w-0 bg-transparent px-4 py-3 text-sm outline-none min-h-[44px]" />
                <button data-testid="newsletter-submit-button" disabled={loading} className="px-4 min-h-[44px] bg-shule-coffee text-shule-paper hover:bg-shule-goldhover transition-colors" aria-label="Abone ol">
                  <ArrowRight className="w-4 h-4" />
                </button>
              </div>
            </form>
            <p className="text-xs text-shule-soft mt-3 leading-relaxed">Erken erişim ve sana özel ayrıcalıklar için.</p>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-shule-lineaccent/60 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-shule-soft">
          <p>© {new Date().getFullYear()} Shule. Tüm hakları saklıdır.</p>
          <p className="font-serif italic text-shule-goldhover text-sm">Küçük Detaylar, Büyük Mutluluklar</p>
        </div>
      </div>
    </footer>
  );
}
